/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import React, { memo, useMemo } from 'react';
import { MenuSection } from '@atlaskit/side-nav-items/menu-section';
import { MenuList } from '@atlaskit/side-nav-items/menu-list';
import { MenuListItem } from '@atlaskit/side-nav-items/menu-list-item';
import { useIntl, defineMessage } from '@atlassian/jira-intl';
import { useProjectsAnalyticsL1 } from '@jira/navigation-apps__sidebar-nav4-analytics/src/common/controllers/use-projects-analytics-l1/index.tsx';
import { expVal } from '@atlassian/jira-feature-experiments';
import { MoreProjectsFlyout } from '@jira/navigation-apps__sidebar-nav4-sidebars-content-projects-more-projects/src/ui/flyout/more-projects-flyout.tsx';
import { BrowseTemplatesMenuItem } from '@jira/navigation-apps__sidebar-nav4-sidebars-content-projects-browse-templates/src/ui/index.tsx';
import { Nav4ProjectsSectionPlacement } from '@jira/growth__nav-4-projects-section/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { Nav4Recommendations } from '@jira/navigation-apps__sidebar-nav4-sidebars-content-growth-recommendations/src/index.tsx';

const moreProjects = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.footer.more-projects',
	// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
	defaultMessage: 'More projects',
	description: 'Message for the more projects flyout in the projects submenu',
});

const moreProjectsGalaxiaMessage = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.footer.more-projects-galaxia',
	// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
	defaultMessage: 'More spaces',
	description: 'Message for the more projects flyout in the projects submenu',
});

function FooterInternal({
	canCreateProject = false,
}: {
	canCreateProject?: boolean | null;
}): React.JSX.Element {
	const moreProjectsGalaxia = expVal('project-terminology-refresh', 'isEnabled', false)
		? moreProjectsGalaxiaMessage
		: moreProjects;
	const { formatMessage } = useIntl();
	const { sendMoreProjectsAnalyticsEvent } = useProjectsAnalyticsL1();

	const recommendations = useMemo(() => {
		if (!canCreateProject) {
			return null;
		}
		return fg('jsmgrowth-459_temporary_gate') ? (
			<Nav4ProjectsSectionPlacement />
		) : (
			<Nav4Recommendations />
		);
	}, [canCreateProject]);

	return (
		<MenuListItem>
			<MenuSection>
				<MenuList>
					<MoreProjectsFlyout onClick={sendMoreProjectsAnalyticsEvent}>
						{formatMessage(moreProjectsGalaxia)}
					</MoreProjectsFlyout>
					{recommendations}
					{canCreateProject &&
						expVal('jsmgrowth_547_rerun_browse_templates_in_sidenav', 'isEnabled', false) && (
							<BrowseTemplatesMenuItem />
						)}
				</MenuList>
			</MenuSection>
		</MenuListItem>
	);
}

export const Footer: React.MemoExoticComponent<typeof FooterInternal> = memo(FooterInternal);
